import { createSelector } from '@reduxjs/toolkit'
import { groupBy } from 'lodash-es'

const applyManagedEventsPopupSelector = ({ managedEventTypes: { applyManagedEventsPopup } }) => applyManagedEventsPopup

export const isOpenSelector = createSelector(
  applyManagedEventsPopupSelector,
  ({ state }) => state === 'open'
)

export const isSlugConflictOpenSelector = createSelector(
  applyManagedEventsPopupSelector,
  ({ state }) => state === 'slug_conflict'
)

export const membershipIdsSelector = createSelector(
  applyManagedEventsPopupSelector,
  ({ membershipIds }) => membershipIds
)

export const selectedIdsSelector = createSelector(
  applyManagedEventsPopupSelector,
  ({ selectedIds }) => selectedIds
)

export const isSubmittingSelector = createSelector(
  applyManagedEventsPopupSelector,
  ({ isSubmitting }) => isSubmitting
)

export const isTouchedSelector = createSelector(
  applyManagedEventsPopupSelector,
  ({ isTouched }) => isTouched
)

export const managedEventsWithSlugConflictsSelector = createSelector(
  applyManagedEventsPopupSelector,
  ({ membershipsWithSlugConflict }) => Object
    .entries(groupBy(membershipsWithSlugConflict.conflicts, ({ slug }) => slug))
    .map(
      ([slug, conflicts]) => {
        const membershipIds = conflicts.map(({ id }) => id)

        return ({
          slug,
          memberships: membershipsWithSlugConflict.memberships.filter(({ id }) => membershipIds.includes(id)),
        })
      }
    )
)
